
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Filtros() { return this.Controlador.Buscador.Filtros; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        public get Modo() { return this.Controlador.Vista.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.Modo = x; }

        public Llamado: string = 'todos';
        @Watch( 'Llamado' )
        onLLamado()
        {
            this.Controlador.Buscador.Filtros.Valores.LlamadoPostVenta = this.Llamado;
            this.Buscador.Buscar( 1 );
        }

        public Abierto: boolean = false;
        public CargandoEtiquetas: boolean = false;

        public BusquedaProvincia: string = '';
        public BuscarProvincia( forzar?: boolean )
        {
            if ( forzar )
                this.BusquedaProvincia = '';
            this.Buscador.Filtros.BusquedaProvincia = this.BusquedaProvincia;
            this.Buscador.Buscar( 1 );

        }

        public BusquedaArticulo: string = '';
        public BuscarArticulo( forzar?: boolean )
        {
            if ( forzar )
                this.BusquedaArticulo = '';
            this.Buscador.Filtros.BusquedaArticulo = this.BusquedaArticulo;
            this.Buscador.Buscar( 1 );
        }

        Seleccionar( x: number )
        {
            if ( this.Filtros.Valores.Limite == x )
                return;
            this.Filtros.Valores.Limite = x;
            this.Buscador.Buscar( 1 );
            this.Refrescar();
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        async Ejecutar()
        {
            if ( !this.Filtros.Tipos[this.Filtros.Valores.Tipo] )
                return;

            this.CargandoEtiquetas = true;
            let tipo = this.Filtros.Tipos[this.Filtros.Valores.Tipo].Valor.map( x => x.Id );
            let pedidos = await Pedido.BuscarPedidosPendientes( tipo.join( ',' ), false ,true);

            if ( !pedidos.hasRows() )
            {
                Utiles.Notificaciones.Error( `No hay pedidos pendientes!` );
                this.CargandoEtiquetas = false;
                return;

            }

            if ( !await Utiles.Mensajes.SiNo( `Imprimir etiquetas para ${this.Filtros.Tipos[this.Filtros.Valores.Tipo].Nombre}`, `¿Está seguro se descargaran aprox ${pedidos.length} etiquetas?` ) )
            {
                this.CargandoEtiquetas = false;
                return;
            }

            Utiles.GenerandoArchivo( true );
            await Pedido.DescargarEtiquetasEnvios( pedidos );
            Utiles.GenerandoArchivo( false );
            this.CargandoEtiquetas = false;
        }
    }
